import { render, staticRenderFns } from "./6s.vue?vue&type=template&id=2b161307&scoped=true&"
import script from "./6s.vue?vue&type=script&lang=js&"
export * from "./6s.vue?vue&type=script&lang=js&"
import style0 from "./6s.vue?vue&type=style&index=0&id=2b161307&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b161307",
  null
  
)

export default component.exports